import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { QuestionBase, StepperQuestion } from '@nx-customer-apps/shared/utils';
import { ComponentsModule, slideDown } from '@nx-customer-apps/components';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'vp-stepper',
    templateUrl: './stepper.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [slideDown],
    imports: [ReactiveFormsModule, ComponentsModule, TranslatePipe]
})
export class StepperComponent {
    @Input() form: FormGroup;
    @Input() question: StepperQuestion;

    get control(): FormControl<number | null> {
        return this.form.get((this.question as QuestionBase<any>).key) as FormControl<number | null>;
    }

    get isInvalid(): boolean {
        return this.control?.invalid && this.control?.touched;
    }

    get errorMessage(): string {
        const errorMessage = this.control?.errors?.['message'];
        return errorMessage || (this.question as QuestionBase<any>).defaultErrorMessage;
    }
}
